import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing1, spacing4 } from 'src/styles/spacing';

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  padding-right: ${spacing1};
  text-align: left;

  @media (min-width: ${breakpointTablet}) {
    padding-right: ${spacing4};
  }
`;

export const StyledImageContainer = styled.div`
  min-width: 40px;
  text-align: left;

  @media (min-width: ${breakpointTablet}) {
    min-width: 56px;
  }
`;

export const StyledContentContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${spacing1};
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const StyledDwellingUnitNumber = styled(Typography)`
  padding-right: ${spacing1};
  margin-top: 0;
`;
